import type { RetentionRow } from '../../customerops/framework';
import { cn } from '../../lib/cn';

type Props = { predictions?: RetentionRow[] };

export function RetentionEnginePanel({ predictions = [] }: Props) {
  return (
    <div className="space-y-2">
      {predictions.map((r) => (
        <div key={r.title} className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <span className="rounded bg-brand-100 px-1.5 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {r.type}
            </span>
            <p className="mt-1 text-sm font-medium">{r.title}</p>
            <p className="mt-0.5 text-xs text-success-600">{r.impact} · {r.customers} customers</p>
          </div>
          <div className="shrink-0 text-right">
            <p className={cn(
              'text-lg font-semibold',
              r.confidence >= 85 ? 'text-success-600' : r.confidence >= 75 ? 'text-brand-600' : 'text-warning-600',
            )}>
              {r.confidence}%
            </p>
            <p className="text-xs text-slate-500">confidence</p>
          </div>
        </div>
      ))}
    </div>
  );
}
